<template>
  <div class="menus" :class="{ opened: isCollapse }">
    <el-menu
      ref="menu"
      :default-active="defaultActive"
      class="el-menu-vertical-demo"
      :collapse="isCollapse"
      :router="true"
      :unique-opened="true"
    >
      <MenuItem v-for="menu in menuList" :menu="menu" v-if="!menu.hidden" :key="menu.path"></MenuItem>
    </el-menu>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { MenusRoutes } from "@/router/index";
import MenuItem from "./MenuItem.vue";
import { notEmpty } from "@/utils/type";
export default {
  name: "Menus",
  components: {
    MenuItem,
  },
  data() {
    return {
      menuList: [],
      defaultActive: "",
    };
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        if (val) {
          if (this.defaultActive === "" || this.defaultActive !== val.path) {
            this.defaultActive = val.path;
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["sidebar"]),
    ...mapGetters("user", ["role"]),
    isCollapse() {
      // console.log("sidebar", this.sidebar);
      return !this.sidebar.opened;
    },
  },
  methods: {
    checkMenu(menus, parentPath = "/staging") {
      let arr = [];
      if (menus && menus.length && this.role) {
        menus.forEach(menu => {
          // console.log("menu", menu);
          const { name, meta, children } = menu,
            path = parentPath + "/" + menu.path;
          let flag = false;
          if (notEmpty(meta.roles)) {
            flag = meta.roles.includes(this.role);
          } else {
            flag = true;
          }
          if (flag) {
            let childrenList = this.checkMenu(children, path);
            if (!meta.hidden) {
              arr.push({
                parentPath: parentPath,
                path,
                name,
                title: meta.title,
                icon: meta.icon,
                hidden: meta.hidden,
                role: meta.role,
                children: childrenList,
              });
            }
          }
        });
        if (arr.length === 0) {
          arr = null;
        }
      } else {
        arr = null;
      }
      return arr;
    },
    findMenu(key, value, arr = this.menuList) {
      let obj = null;
      if (arr && arr.length) {
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i];
          if (item[key] === value) {
            obj = item;
          } else {
            if (item.children && item.children.length) {
              let tar = this.findMenu(key, value, item.children);
              if (tar) {
                obj = tar;
              }
            }
          }
          if (obj) {
            break;
          }
        }
      }
      return obj;
    },
    menuClick(path) {
      var menu = this.findMenu("path", path);
      // console.log("menu", menu);
      if (menu.children && menu.children.length) {
        menu.open = !menu.open;
      } else {
        this.$router.push({ path: menu.path }, null, error => {});
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.menuList = this.checkMenu(MenusRoutes);
      // console.log("menuList", this.menuList);
    });
  },
};
</script>
<style lang="less" scoped>
.el-menu {
  border: none;
}
</style>
